import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ContextLanguage } from "../../../context/Context.Language";
import {
  TEXT_AND,
  TEXT_AN_ORDER_NOW,
  TEXT_AS_PRO_WELCOME,
  TEXT_AVAILABLE,
  TEXT_BANGKOK,
  TEXT_BEST_MACHINE,
  TEXT_COVER_ALL_YOUR_MB,
  TEXT_CREATE,
  TEXT_FIXED_PRICE,
  TEXT_FIXED_PRICE_MB,
  TEXT_FOR_THEBEST_WASH,
  TEXT_FROM_SMALL_TO_BIG,
  TEXT_IRONING_AND_MUCH_MORE_MB,
  TEXT_LOADS_FROM_MB,
  TEXT_OUR_CONFIXED,
  TEXT_PATTAYA,
  TEXT_RESULT_MB,
  TEXT_SELECT,
  TEXT_TO_PRO_MB,
  TEXT_TO_PRO_MB_2,
  TEXT_TYPES_OF_SHOES,
  TEXT_WASH_BY_YOURSELF,
  TEXT_WASH_BY_YOURSELF_TH,
  TEXT_WASH_IRON_CLEAN,
  TEXT_WASH_MACHINE_TH,
  TEXT_WASH_YOUR_SHOES,
  TEXT_WELCOME_AND_SAWASDEE,
  TEXT_WELCOME_DES_ALL,
  TEXT_WITHOUT_IRONING,
  TEXT_YOUR_PROGRAM_NOW,
  TEXT_YOU_PREFER_MB,
} from "../../../utils/useConstants";
import { useIsMobile } from "../../../utils/useIsMobile";
import {
  STYLE_AVALIABLE_HOME_WELCOME,
  STYLE_BLUE_SEMIBOLD,
  STYLE_DES_HOME_WELCOME,
  STYLE_IMG_SECTION,
  STYLE_LINK_BLUE,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_PADDING_WINDOWS,
  STYLE_UNDERLINE_BLUE_24_16,
  STYLE_WASH_IRON_CLEAN_HOME_WELCOME,
  STYLE_WIDTH_CONTENT,
} from "../../../utils/useStyle";

const EN = ({ language }) => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div className={`${STYLE_DES_HOME_WELCOME(language)} md:px-4 `}>
      {/* {isMobile ? (
        <div className={STYLE_DES_HOME_WELCOME}>
          <div>{TEXT_TO_PRO_MB[language]}</div>
          <div>{TEXT_TO_PRO_MB_2[language]}</div>
          <div> {TEXT_FIXED_PRICE_MB[language]}</div>
          <div> {TEXT_COVER_ALL_YOUR_MB[language]}</div>
          <div>{TEXT_LOADS_FROM_MB[language]}</div>
          <div>{TEXT_IRONING_AND_MUCH_MORE_MB[language]}</div>
          <div>{TEXT_RESULT_MB[language]}</div>
          <div>{TEXT_YOU_PREFER_MB[language]}</div>
          <div>
            {TEXT_WASH_YOUR_SHOES[language]}{" "}
            <span>{TEXT_TYPES_OF_SHOES[language]}</span>
          </div>
          <div>
            <span
              onClick={() => {
                navigate("/OurServices");
              }}
              className={`${STYLE_LINK_BLUE} mx-1`}
            >
              {TEXT_SELECT[language]}
            </span>
            {TEXT_YOUR_PROGRAM_NOW[language]}
          </div>
        </div>
      ) : (
        <div className={STYLE_DES_HOME_WELCOME}>
          <div>{TEXT_AS_PRO_WELCOME[language]}</div>
          {TEXT_FIXED_PRICE[language]}
          {TEXT_OUR_CONFIXED[language]}
          <div>{TEXT_FROM_SMALL_TO_BIG[language]},</div>
          {TEXT_WITHOUT_IRONING[language]} ,{TEXT_FOR_THEBEST_WASH[language]} ,
          {TEXT_BEST_MACHINE[language]}
          <div>
            {" "}
            {TEXT_WASH_BY_YOURSELF[language]} {TEXT_WASH_YOUR_SHOES[language]}
          </div>
         
        </div>
      )} */}
      {TEXT_WELCOME_DES_ALL[language]}
      <div>
        <span
          onClick={() => {
            navigate("/OurServices");
          }}
          className={STYLE_LINK_BLUE}
        >
          {TEXT_CREATE[language]}
        </span>
        {TEXT_AN_ORDER_NOW[language]}
      </div>
    </div>
  );
};

const TH = ({ language }) => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div>
      {isMobile ? (
        <div className={STYLE_DES_HOME_WELCOME}>
          <div>{TEXT_TO_PRO_MB[language]}</div>
          <div> {TEXT_FIXED_PRICE_MB[language]}</div>
          <div> {TEXT_COVER_ALL_YOUR_MB[language]}</div>
          <div>{TEXT_LOADS_FROM_MB[language]}</div>
          <div>{TEXT_IRONING_AND_MUCH_MORE_MB[language]}</div>
          <div>{TEXT_RESULT_MB[language]}</div>
          <div>{TEXT_WASH_MACHINE_TH[language]}</div>
          <div>{TEXT_YOU_PREFER_MB[language]}</div>
          <div>{TEXT_WASH_BY_YOURSELF_TH[language]}</div>
          <div>{TEXT_WASH_YOUR_SHOES[language]}</div>
          <div>
            <span
              onClick={() => {
                navigate("/OurServices");
              }}
              className={`${STYLE_BLUE_SEMIBOLD} mx-1`}
            >
              {TEXT_SELECT[language]}
            </span>
            {TEXT_YOUR_PROGRAM_NOW[language]}
          </div>
        </div>
      ) : (
        <div className={STYLE_DES_HOME_WELCOME}>
          <div>{TEXT_AS_PRO_WELCOME[language]}</div>
          <div>{TEXT_FIXED_PRICE[language]}</div>
          <div>{TEXT_OUR_CONFIXED[language]}</div>
          <div>{TEXT_FROM_SMALL_TO_BIG[language]}</div>
          <div>{TEXT_WITHOUT_IRONING[language]}</div>
          {TEXT_FOR_THEBEST_WASH[language]}
          <div>{TEXT_BEST_MACHINE[language]}</div>
          <div> {TEXT_WASH_BY_YOURSELF[language]}</div>
          <div>
            {TEXT_WASH_YOUR_SHOES[language]}
            <span
              onClick={() => {
                navigate("/OurServices");
              }}
              className={`${STYLE_LINK_BLUE}`}
            >
              {TEXT_SELECT[language]}
            </span>
            {TEXT_YOUR_PROGRAM_NOW[language]}
          </div>
        </div>
      )}
    </div>
  );
};

const Welcome = () => {
  const { language } = React.useContext(ContextLanguage);
  return (
    <div className={`${STYLE_WIDTH_CONTENT} px-4 md:px-0 `}>
      <div
        className={`${
          language === "TH"
            ? " text-22-th md:text-28-th "
            : " text-22 md:text-28 "
        } font-bold  leading-8.3 text-laudry-gray-200 text-center`}
      >
        {TEXT_WELCOME_AND_SAWASDEE[language]}
      </div>
      <div className={STYLE_UNDERLINE_BLUE_24_16}></div>
      <div className=" h-login_button">
        <div className={`${STYLE_WASH_IRON_CLEAN_HOME_WELCOME(language)}`}>
          {TEXT_WASH_IRON_CLEAN[language]}
        </div>
        <div className={`${STYLE_AVALIABLE_HOME_WELCOME(language)}`}>
          <div className="mr-1"> {TEXT_AVAILABLE[language]}</div>
          <div> {TEXT_BANGKOK[language]} </div>
          {/* <div className=" mx-1"> {TEXT_AND[language]}</div> */}
          {/* <div> {TEXT_PATTAYA[language]}</div> */}
        </div>
      </div>

      <EN language={language} />
      {/* {language === CONSTANT_LANGUAGE.EN ? (
        <EN language={language} />
      ) : (
        <TH language={language} />
      )} */}
    </div>
  );
};

const HomeWelcome = () => {
  const isMobile = useIsMobile();
  return (
    <div className={`bg-laundry-bglight w-full  `}>
      <div className={`py-6.5 md:py-13.5 ${STYLE_MAX_WIDTH_DESKTOP} `}>
        {isMobile ? (
          <div>
            <Welcome />
            <img
              src="/images/welcome.png"
              className={`${STYLE_IMG_SECTION} mx-auto md:mx-0`}
            />
          </div>
        ) : (
          <div
            className={`grid md:grid-cols-2 items-center ${STYLE_PADDING_WINDOWS}`}
          >
            <img src="/images/welcome.png" className={STYLE_IMG_SECTION} />
            <Welcome />
          </div>
        )}
      </div>
    </div>
  );
};

export default HomeWelcome;
